export default __webpack_public_path__ + "static/media/index-04.a8b97a38.jpg";